"use client";

import { LabelHTMLAttributes } from "react";
interface Props extends LabelHTMLAttributes<HTMLLabelElement>{
    title?: string,
    font?:"medium",
    className?:string,    
}
export default function ({title,font="medium",className="mb-2",children,...rest}:Props) {
  return (
    <label {...rest} className={`block text-sm ${className} font-${font}`}>
      {title}
      {children}
    </label>
  );
}
